/* eslint-disable jsx-a11y/media-has-caption */
import { useCallback, useEffect, useRef, useState } from 'react';
import { IConversationViewModel } from 'viewModels';
import { Tooltip } from '@mui/material';
import { useAuth } from '../../context';
import { useConversation } from '../../context/conversation';
import { UserProfilePicture } from '../UserProfilePicture';
import { Body, Container, Content } from './styles';
import { ReactComponent as ReadIcon } from '../../assets/icons/check-message-read.svg';
import { ReactComponent as SendIcon } from '../../assets/icons/check-message.svg';
import { AudioWithDownload } from '../AudioWithDownload';

interface ConversationProps {
  conversationId?: string;
  scroll?: boolean;
}

export function Conversation({ conversationId, scroll }: ConversationProps) {
  const { conversations, setActiveConversationId } = useConversation();
  const { user } = useAuth();
  const ref = useRef<HTMLDivElement>(null);
  const [conversationSelected, setConversationSelected] = useState<
    IConversationViewModel | undefined
  >(undefined);

  useEffect(() => {
    setActiveConversationId(conversationId);
    setConversationSelected(conversations.find((c) => c.id === conversationId));
  }, [conversationId, conversations, setActiveConversationId]);

  const handleScroll = useCallback(() => {
    if (ref.current) {
      const element = ref.current;
      element.scrollTo(0, element.scrollHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref?.current?.scrollHeight]);

  const getUserName = (id: string) => {
    const findedUser = conversationSelected?.participants.find((u) => u.id === id);
    const name = `${findedUser?.firstName ?? ''} ${findedUser?.lastName ?? ''}`;
    return name;
  };

  useEffect(() => {
    if (scroll) {
      handleScroll();
    }
  }, [handleScroll, scroll]);

  useEffect(() => {
    handleScroll();
  }, [handleScroll]);

  return (
    <Container>
      <Body ref={ref}>
        {conversationId &&
          conversationSelected?.messages.map((message) =>
            message.createdById === user.id ? (
              <Content
                isSend={message.createdById === user.id}
                key={new Date(message.createdAt).getTime()}>
                <div className="contentConversationMessage">
                  <p style={{ display: 'flex', justifyContent: 'flex-end' }}>Você</p>
                  <div className="containerMessage">
                    {!message.attachment ? (
                      <p className="message">{message.text} </p>
                    ) : (
                      <>
                        <AudioWithDownload attachmentId={message.attachment.id as string} />
                        <p className="message">{message.text} </p>
                      </>
                    )}

                    {message?.infos?.some((i) => i.createdById !== user.id && i.isReaded) ? (
                      <ReadIcon className="read" />
                    ) : (
                      <SendIcon className="send" />
                    )}
                  </div>
                  <p>
                    {new Date(message?.createdAt).toLocaleString('pt-BR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </p>
                </div>
                <div>
                  <UserProfilePicture pictureId={user.profilePictureId} />
                </div>
              </Content>
            ) : (
              <Content isSend={message.createdById === user.id} key={message.id}>
                <Tooltip
                  disableInteractive
                  title={getUserName(message.createdById)}
                  placement="left"
                  arrow>
                  <div>
                    <UserProfilePicture
                      pictureId={
                        conversationSelected.participants.find((u) => u.id === message.createdById)
                          ?.profilePictureId
                      }
                    />
                  </div>
                </Tooltip>
                <div className="contentConversationMessage">
                  <p>{getUserName(message.createdById)}</p>
                  <div className="containerMessage">
                    {!message.attachment ? (
                      <p className="message">{message.text} </p>
                    ) : (
                      <AudioWithDownload attachmentId={message.attachment.id as string} />
                    )}

                    {message?.infos?.some((i) => i.createdById !== user.id && i.isReaded) ? (
                      <ReadIcon className="read" />
                    ) : (
                      <SendIcon className="send" />
                    )}
                  </div>
                  <p>
                    {new Date(message?.createdAt).toLocaleString('pt-BR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </p>
                </div>
              </Content>
            ),
          )}
      </Body>
      {conversations
        .filter((c) => conversationId === c.id)
        .map(
          (conversation) =>
            conversation.messages.find((m) =>
              m.infos?.find((i) => i.createdById === user.id && !i.isReaded),
            ) && (
              <div className="containerMessagesUnreads" key={conversation.id}>
                <p className="messagesUnreads">
                  {conversation.messages.filter((m) =>
                    m.infos?.some((i) => i.createdById === user.id && !i.isReaded),
                  ).length > 1
                    ? `${
                        conversation.messages.filter((m) =>
                          m.infos?.some((i) => i.createdById === user.id && !i.isReaded),
                        ).length
                      }  messagens não lidas`
                    : `${
                        conversation.messages.filter((m) =>
                          m.infos?.some((i) => i.createdById === user.id && !i.isReaded),
                        ).length
                      } mensagem não lida`}
                </p>
              </div>
            ),
        )}
    </Container>
  );
}
